module.exports = __webpack_public_path__ + "img/chatbot2.928affee.svg";